// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"9ee59377","288":"254a535b","320":"87591185","419":"197c3cfb","467":"dd9146c2","638":"f4f474e2","760":"b82ec3a3","901":"5f7d0841","989":"5103c601"}[chunkId] + ".chunk.js";
};